import React, { useState } from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import { toast } from "react-toastify";
import { Toaster } from 'react-hot-toast';

const EmailForm = () => {
    const { eventId } = useParams();
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [status, setStatus] = useState(null);

    const navigate = useNavigate();

    const handleCancel = () => {
        navigate(`/events/view-event/${eventId}`);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!subject.trim() || !message.trim()) {
            setStatus({
                type: 'error',
                message: 'Please fill in both subject and message fields.'
            });
            return;
        }

        setIsSubmitting(true);
        setStatus(null);

        try {
            const formData = new FormData();
            formData.append('event_id', eventId);
            formData.append('subject', subject);
            formData.append('message', message);

            const response = await fetch('/otgservices/sendEventUsersAnEmail.php', {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                throw new Error(`Server responded with status: ${response.status}`);
            }

            const data = await response.json();

            if (data.status === 'success') {
                setStatus({
                    type: 'success',
                    message: 'Email sent successfully!'
                });

                // Reset form after successful submission
                setSubject('');
                setMessage('');
                let eventUrl = '/events/view-event/' + eventId;
                toast.success("Mail sent successfully!");
                setTimeout(() => navigate(eventUrl), 1500);
            } else {
                setStatus({
                    type: 'error',
                    message: data.message || 'Failed to send email. Please try again.'
                });
            }
        } catch (error) {
            console.error('Error sending email:', error);
            setStatus({
                type: 'error',
                message: 'An error occurred while sending the email. Please try again later.'
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <Toaster position="top-right" reverseOrder={false} />
            <div className="max-w-2xl mx-auto p-6 bg-white rounded shadow">
                <h2 className="text-xl font-bold mb-4">Send Email to Event Participants</h2>

                {status && (
                    <div className={`p-4 mb-4 rounded ${
                        status.type === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
                    }`}>
                        {status.message}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label htmlFor="subject" className="block mb-1 font-medium">
                            Subject
                        </label>
                        <input
                            type="text"
                            id="subject"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded"
                            disabled={isSubmitting}
                            required
                        />
                    </div>

                    <div className="mb-4">
                        <label htmlFor="message" className="block mb-1 font-medium">
                            Message
                        </label>
                        <textarea
                            id="message"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded h-32"
                            disabled={isSubmitting}
                            required
                        />
                    </div>

                    <div className="flex gap-4">
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className={`px-4 py-2 rounded text-white ${
                                isSubmitting ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'
                            }`}
                        >
                            {isSubmitting ? 'Sending...' : 'Send Email'}
                        </button>
                        <button
                            type="button"
                            onClick={handleCancel}
                            disabled={isSubmitting}
                            className="px-4 py-2 rounded text-gray-700 bg-gray-200 hover:bg-gray-300"
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default EmailForm;